<template>
  <div ng-view="">
    <div class="float-right" width="300">
        <a href="../assets/ster.jpg"><img class="float-right" width="300" src="../assets/ster.png"></a>
        <br class="clear">
    </div>
  <H3>
    Led Dimmer Pro V5
    </h3>
    <h4>
        sterownik oświetlenia LED 
    </h4>
    <h6>
        Pierwsza wersja sterownika powstała w roku 2011. Aktualnie w sprzedaży jest piąta generacja (V5).
    </h6>
<p>
    Przygotowaliśmy sterownik oświetlenia LED, który pozwala na płynną regulację jasności podłączonych modułów LED. Sterownik przeznaczony jest dla akwarystów
    (dzięki możliwości symulowania zmierzchu i świtu), ale pozwala też ograniczyć koszty (np. dzięki zmiejszeniu oświetlenia gdy prąd jest droższy).
</p>

<p>
    Sterownik posiada następujące cechy:
    </p><ul>
        <li>możliwość programowania przez WiFi</li>
        <li>automatyczna aktualizacja oprogramowania przez WiFi</li>
        <li>
            steruje jasnością świecenia w sposób płynny (jeżeli ustawimy, że o danej godzinie ma być wyłączone oświetlenie a pięć minut później ma świećić maksymalnie
            jasno, to jasność świecenia będzie się zmieniała w tym czasie w sposób płynny)
        </li>
        <li>pozwala na programowanie z dokładnością do jednej minuty</li>
        <li>
            maksymalna ilość ustawień (punktów zmiany jasności świecenia) to 250 - np. jeżeli chcemy włączyć świecenie w godzinach 6-22 to potrzebujemy do tego
            czterech ustawień: np: 6:00 - brak świecenia, 6:05 - maksimum, 22:00 - maksimum, 22:05 - brak świecenia
        </li>
        <li>ustawienia są przechowywane pomimo zaniku napięcia (nazależnie od długości przerwy)</li>
        <li>ustawiony czas jest prawidłowo zmieniany również w przypadku braku napięcia - wewnętrzna bateria CR2032 - wymagana wymiana co kilka lat</li>
        <li>czas jest automatycznie zmieniany z zimowego na letni i odwrotnie</li>
        <li>możliwość zaprogramowania różnych ustawień dla różnych dni tygodnia i miesięcy (dowolne kombinacje)</li>
        <li>czujnik stanu baterii zegara (opcjonalny czujnik temperatury zewnętrznej)</li>
        <li>zabezpieczenie przed odwrotnym podłączeniem zasilania</li>
        <li>zabezpieczenie wyjść przed wyładowaniami elektrostatycznymi</li>        
    </ul>    
<p>
    Specyfikacja techniczna:
    </p><ul>
        <li>Zasilanie 9V-38V</li>
        <li>Maksymalne obciążenie: 21A</li>
        <li>Maksymalne obciążenie kanału: 3A</li>
        <li>Ilość kanałów: 7</li>
        <li>Wymiary: 8.2cm x 6.7cm x 2,6 cm</li>
        <li>Zasilanie wyjść jest jednocześnie zasilaniem sterownika</li>
        <li>Wewnętrzna bateria CR2032 (podtrzymanie zegara) - wymiana co kilka lat</li>
    </ul>
    <div class="images float-right" width="300">        
        <a href="http://ldp.palabras.pl" target="_blank"><img class="float-right" width="150" src="../assets/app1.png"></a>
        <a href="http://ldp.palabras.pl" target="_blank"><img class="float-right" width="150" src="../assets/app2.png"></a>
        <a href="http://ldp.palabras.pl" target="_blank"><img class="float-right" width="150" src="../assets/app3.png"></a>
    </div>
    <h4>Aplikacja online - <a href="http://ldp.palabras.pl">http://ldp.palabras.pl</a></h4>
    <p>
        Dostępna jest też aplikacja mobilna (online) do obsługi podstawowych funkcji sterownika. 
    </p>
    
    <h4>Zamówienia i sprzedaż - <a href="http://sklep.palabras.pl">http://sklep.palabras.pl</a></h4>
    W przypadku chęci zamówienia większej ilości proszę o kontakt przez formularz kontaktowy (w sklepie) w celu ustalenia szczegółów.
<h4>Pomoc</h4>
<p>
    Pomoc do sterownika, dodatkowe informacje i wsparcie techniczne można uzyskać na grupie dyskusyjnej.
    <a href="http://forum.palabras.pl">Zapraszamy na grupę dyskusyjną.</a>
    <br>
    Zobacz też historię powstawania sterownika i opinie
    <a href="http://forum.klub-malawi.pl/sterownik-oswietlenia-led-szukam-testerow-t25595.html">w wątku na forum klubu Malawi.</a>
</p>

</div>
</template>

<script>

export default {
  name: 'home',
  components: {      
  },  
  data: function() {
      return {         
      }
  }
}
</script>

<style scoped>
    .images img {
        padding: 5px;
    }
</style>